<div class="aems-bread-crumb m-b-16">
    <a class="m-r-4" routerLink="/master-data">Master Data</a><span>/ {{"Repair Code"}}</span>
</div>

<form [formGroup]="filterFormGroup" class="list-repair-code-container">
    <div class="pure-g">
        <div class="pure-u-md-10-24 pure-u-lg-14-24">
            <h3 class="inline m-r-4" i18n>Repair Code</h3>
        </div>
        <div class="pure-u-md-14-24 pure-u-lg-10-24 right">
            <app-repair-code-search class="search-bar"
                [repairCodeSearchTextForm]="filterFormGroup.controls.repairCodeSearchTextForm"></app-repair-code-search>
        </div>
    </div>
    <app-repair-code-filters [filterFormGroup]="filterFormGroup"></app-repair-code-filters>
    <app-repair-code-grid [filterFormGroup]="filterFormGroup" class="table-container"></app-repair-code-grid>
</form>
